/** Filtros */
import React, { Component } from "react";

import "./styles.css";
import { Icon } from "antd";
import Condition from "./Condition";

export default class Filter extends Component {
  state = {
    conditions: []
  };

  handleSetCondition = (id, cond) => {
    // Atualiza a lista de condições
    const conds = this.state.conditions;
    let obj = conds.filter(b => b.id === id);

    if (obj.length > 0) {
      obj = obj[0];
      obj.param = cond;
    }

    const params = {};

    conds.map(param => {
      params[`${param.param.label}`] = param.param.value;
    });

    // Executa a função do componente pai para atualizar os parâmetros da requisição
    this.props.paramSetter(params);
  };

  handleAddCondition = () => {
    const size = this.state.conditions.length + 1;

    this.setState({
      conditions: [
        ...this.state.conditions,
        {
          id: size * Math.random() + 5 // Id aletório para cada filtro adicionado pelo usuário
        }
      ]
    });
  };

  handleDeleteCondition = id => {
    // Deleta uma condição
    const cond = this.state.conditions.filter(obj => obj.id == id);
    const conditions = [];

    if (cond.length > 0) {
      let cond_obj = cond[0];
      this.state.conditions.map(obj => {
        if (obj.id != cond_obj.id) conditions.push(obj);
      });

      if (cond != null) {
        this.setState({
          conditions
        });
      }
    }

    const params = {};

    conditions.map(param => {
      params[`${param.param.label}`] = param.param.value;
    });

    /**
     * Executa a função do componente pai para atualizar os parâmetros da requisição
     * no formado do django filters.
     */
    this.props.paramSetter(params);
  };

  render() {
    return (
      <div className="filter__container">
        <div className="filter__filters">
          {this.state.conditions.map(cond => (
            <Condition
              data={cond}
              options={this.props.data}
              key={cond.id}
              handleDelete={this.handleDeleteCondition}
              conditionSet={this.handleSetCondition}
            />
          ))}
        </div>
        <a onClick={this.handleAddCondition}>
          <Icon type="plus" /> Adicionar condição
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/index.js